import {
  sendGetHttpRequest,
  sendPostHttpRequest,
  sendHttpRequest,
} from "lib/fetcher";
import Cookies from "js-cookie";

export async function getCaseList(orgId: string, query: string) {
  return await sendGetHttpRequest(`/case/cases${query}`, orgId);
}

export async function getCaseDetail(
  orgId: string,
  isCustomer: boolean,
  caseId: string,
) {
  return await sendGetHttpRequest(
    `/case/cases/${caseId}?withLocation=true&withCustomer=${!isCustomer}&withAlertNote=true`,
    orgId,
  );
}

export async function getSharedCaseDetail(orgId: string, caseId: string) {
  return await sendGetHttpRequest(
    `/pub/case/shares/${caseId}?withLocation=true&withCustomer=true&withAlertNote=true`,
    orgId,
  );
}

export async function getCaseCount(orgId: string, status: string) {
  return await sendGetHttpRequest(
    `/case/cases/status/count?status=${status}`,
    orgId,
  );
}

export async function getMergeableCaseList(
  orgId: string,
  alertId: string,
  displayId: string,
  withCustomer: boolean,
  forCase: boolean,
) {
  return await sendGetHttpRequest(
    `/case/cases/mergeable?alertId=${alertId}&displayId=${displayId}&withCustomer=${withCustomer}&forCase=${forCase}`,
    orgId,
  );
}

export async function getSiteDetail(orgId: string, id: number) {
  return await sendGetHttpRequest(
    `/site/sites/normal/${id}?withManager=true&with_geolocation=true`,
    orgId,
  );
}

export async function mergeAlertToCase(
  orgId: string,
  caseId: string,
  alertId: string,
) {
  return await sendPostHttpRequest(
    "case/cases/merge_into",
    {
      alertId,
      caseId,
    },
    orgId,
  );
}

export async function mergeCaseToCase(
  orgId: string,
  destCaseId: string,
  srcCaseId: string,
) {
  return await sendPostHttpRequest(
    "/case/cases/merge_case_into",
    {
      destinationCaseId: destCaseId,
      sourceCaseId: srcCaseId,
    },
    orgId,
  );
}

export async function findCaseNotes(orgId: string, caseId: string) {
  return await sendGetHttpRequest(`/case/cases/${caseId}/notes`, orgId);
}

export const changeCaseStatus = async (
  orgId: string,
  caseId: string,
  newStatus: string,
  tag: string,
  desc: string,
) => {
  return await sendPostHttpRequest(
    `/case/cases/${caseId}/change_status`,
    {
      status: newStatus,
      tag: {
        name: tag,
        desc,
      },
    },
    orgId,
  );
};
export async function addCaseNote(orgId: string, caseId: string, note: string) {
  return await sendPostHttpRequest(
    `case/cases/${caseId}/notes`,
    {
      note,
    },
    orgId,
  );
}

export async function shareCase(
  caseId,
  emails,
  phoneNumbers,
  expiration,
  note,
  orgId,
) {
  return await sendPostHttpRequest(
    "sharing/shares/public/case",
    JSON.stringify({
      data: {
        caseId,
        contacts: {
          manualEmailNotifier: {
            emails,
          },
          manualSmsNotifier: {
            phoneNumbers,
          },
        },
        expiration: expiration ? parseInt(expiration) : undefined,
        note,
      },
    }),
    orgId,
  );
}
export async function addArchiveToCase(
  caseId: string,
  data: any,
  orgId?: string,
) {
  return await sendHttpRequest({
    method: "post",
    url: `/case/cases/${caseId}/archive`,
    data: data,
    headers: {
      "Content-Type": "application/json",
      "x-org-id": orgId ?? Cookies.get("orgId"),
    },
  });
}

export async function deleteArchiveToCase(
  caseId: string,
  archiveId: string,
  orgId?: string,
) {
  return await sendHttpRequest({
    method: "delete",
    url: `/case/cases/${caseId}/archive/${archiveId}`,
    headers: {
      "Content-Type": "application/json",
      "x-org-id": orgId ?? Cookies.get("orgId"),
    },
  });
}

export function getCameraById(cameraId, orgId = undefined) {
  return sendHttpRequest({
    url: `/camera/cameras/${cameraId}?withNvr=true&withChannelId=true`,
    method: "GET",
    headers: orgId && {
      "x-org-id": orgId,
    },
  });
}
